import { cn } from '@/lib/utils';

export function Logo({ className, withTagline }: { className?: string; withTagline?: boolean }) {
  return (
    <div className={cn('inline-flex items-center gap-2 select-none', className)}>
      <span className="font-serif text-2xl tracking-tight">
        Parecer<span className="text-accent">.</span>ai
      </span>
      {withTagline && (
        <span className="hidden sm:inline-block text-xs text-muted-foreground border-l border-border pl-2 ml-1">
          revisão jurídica com IA
        </span>
      )}
    </div>
  );
}
